import React, { useEffect } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { fetchPatientFilesDownloadUrlsAction } from '../../../reducers/patients';
import { isImage } from '../../../helpers';
import { formatTimestamp } from '../../../helpers/time';
import { sortNewestCallback } from '../../../helpers/patientFiles';
import Modal from '../../../components/CustomReactImages/Modal';

const PatientFilesFullScreenGalary = ({ patient, isOpen, setOpen, fileTypeId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchPatientFilesDownloadUrlsAction(patient.id, fileTypeId));
    }
  }, [isOpen, dispatch, patient.id, fileTypeId]);

  const loadedIDBImageFiles = get(patient, `files[${fileTypeId}]`, []).filter(file =>
    isImage(file.name)
  );
  loadedIDBImageFiles.sort(sortNewestCallback);

  if (!isOpen) {
    return '';
  }

  return (
    <Modal
      images={loadedIDBImageFiles.map(image => ({
        src: image.url,
        caption: formatTimestamp(image.updated_at)
      }))}
      onClose={() => setOpen(false)}
    />
  );
};

PatientFilesFullScreenGalary.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  fileTypeId: PropTypes.number.isRequired
};

export default PatientFilesFullScreenGalary;
